import { useCallback, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import AssessmentResult from 'components/assessment-result';
import { ADHD_ASSESSMENT_RESULT } from 'constants/localStorageKey';

const AdhdAssessmentResult = () => {
  const history = useHistory();
  const data = localStorage.getItem(ADHD_ASSESSMENT_RESULT);

  const backToIntro = useCallback(() => {
    history.push('/adhd-self-test');
  }, [history]);

  useEffect(() => {
    return () => {
      if (history.action === 'POP') {
        backToIntro();
      }
    };
  }, [history, backToIntro]);

  if (!data) {
    backToIntro();
    return <></>;
  }

  return <AssessmentResult data={data} />;
};

export default AdhdAssessmentResult;
